import clsx from 'clsx'

import { FooterLinks } from '~/constants'
import useTrackClick from '~/events/trackers/useTrackClick'
import { useCommonTx } from '~/hooks/useTranslationForNamespace'

type FooterLinkKeys = keyof typeof FooterLinks
type FooterLinkCodes = typeof FooterLinks[FooterLinkKeys]['code']

interface FooterProps {
  className?: string
  // showLinks will show the links with the keys provided
  // if not provided, all links will be shown
  showLinks?: Array<FooterLinkCodes>
}

const Footer = ({ className, showLinks }: FooterProps) => {
  const t = useCommonTx('common')
  const year = new Date().getFullYear()
  const { trackCta } = useTrackClick()

  const footerLinksMap = {
    termsOfService: {
      ...FooterLinks['termsOfService'],
      clickName: 'terms_of_service',
      destination: 'terms_of_service',
      label: t(`footer.termsOfService`),
    },
    privacyPolicy: {
      ...FooterLinks['privacyPolicy'],
      clickName: 'privacy_policy',
      destination: 'privacy_policy',
      label: t(`footer.privacyPolicy`),
    },
    californiaPrivacy: {
      ...FooterLinks['californiaPrivacy'],
      clickName: 'california_privacy',
      destination: 'california_privacy',
      label: t(`footer.californiaPrivacy`),
    },
    help: {
      ...FooterLinks['help'],
      clickName: 'visit_helpdesk',
      destination: 'help_center',
      label: t(`footer.help`),
    },
  } as const

  const listOfFooterLinks = Object.values(footerLinksMap)
  const filteredLinks = showLinks
    ? listOfFooterLinks.filter((item) => showLinks.includes(item.code))
    : listOfFooterLinks

  const handleClick = (item: typeof filteredLinks[number]) => {
    trackCta({
      click_name: item.clickName,
      destination: item.destination,
      text: item.label,
      type: 'link',
    })
  }

  return (
    <div
      className={clsx(
        'p-10 text-caption-2 font-semibold text-text-subdued mb-5 text-center sm:text-left',
        'flex flex-col sm:flex-row gap-5 sm:gap-8 items-center sm:items-end',
        className,
      )}
    >
      <div className='uppercase flex-1'>© {year} LUMOS LABS, INC.</div>
      {filteredLinks.map((item) => (
        <a key={item.code} href={item.url} onClick={() => handleClick(item)}>
          {item.label}
        </a>
      ))}
    </div>
  )
}

export default Footer
